// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {ReactNode, useEffect, useRef} from 'react';
import cn from 'classnames';
import {Link, useLocation} from 'react-router-dom';
import {use_theme} from '../../../../hola/pub/settings_ctx';
import Icon_chevron_down from '../../../../hola/pub/img/hola2023/icons/16/chevron_down.svg';
import {Pricing_menu} from './pricing_menu';
import {Locations_menu} from './locations_menu';
import {Resources_menu} from './resources_menu';
import {Product_menu} from './product_menu';
import {use_translation_v} from '../../../../hola/pub/lib/trans_v';
import {use_screen} from '../../../../hola/pub/lib/screen_util';
import {use_debug_ui} from '../../../../hola/pub/lib/debug';

import styles from './nav_menu.module.less';

interface i_menu_item_props {
    id: string;
    to: string;
    title: string;
    content?: ReactNode;
}
export const Menu_item = (props: i_menu_item_props)=>{
    const {id, to, title, content} = props;
    const {is_client} = use_screen();
    const {theme} = use_theme({def: 'hola2023'});
    const {T} = use_translation_v({no_defaults: true});
    const ref = useRef<HTMLDivElement>();
    const location = useLocation();
    const debug_nav_menu_cards = use_debug_ui('updated_nav_menu_cards');
    useEffect(()=>{
        if (!ref.current)
            return;
        const calc_shift = ()=>{
            const shift = ref.current.getBoundingClientRect().left;
            ref.current.style.setProperty('--left', `${shift}px`);
        };
        calc_shift();
        window.addEventListener('resize', calc_shift);
        return ()=>{
            window.removeEventListener('resize', calc_shift);
        };
    }, [ref.current, location.pathname]);
    // const Link_tag = to == '#' ? 'a' : Link;
    return <div className={cn(styles.menu_item, styles[id],
      debug_nav_menu_cards && styles[`${id}_new`])} ref={ref}>
      <div className={styles.menu_link}>
        <Link to={to} className={cn(theme.P, theme.p3)}
          data-clickid={`nav_${id}`}><T>{title}</T></Link>
        {content && <Icon_chevron_down className={styles.link_icon}/>}
      </div>
      {is_client && content && <div className={styles.menu_content}>
        {content}</div>}
    </div>;
};

interface i_nav_menu_props {
    visible: boolean;
}
export const Nav_menu = (props: i_nav_menu_props)=>{
    const {visible = true} = props;
    return <div className={cn(styles.nav_menu, styles.toolip_nav_menu,
      visible && styles.visible)}>
      <Menu_item id="products" to="/products" title="Products"
        content={<Product_menu/>}/>
      <Menu_item id="locations" to="/proxy-location"
        title="Locations"
        content={<Locations_menu/>}/>
      <Menu_item id="resources" to="#" title="Resources"
        content={<Resources_menu/>}/>
      <Menu_item id="pricing" to="/pricing?ref=navbar" title="Pricing"
        content={<Pricing_menu/>}/>
    </div>;
};
